import { getLiquidToInsert } from 'cio/utils/liquid';

export default {
  name: 'wysihtml5',

  initialize() {
    wysihtml5.commands.insertLiquid = {
      exec(composer, command, value, fallback, templateEngine) {
        let doc;
        let textNode;
        let whiteSpace;

        doc = composer.doc;
        textNode = doc.createTextNode(getLiquidToInsert(value, fallback, templateEngine));
        composer.selection.insertNode(textNode);
        whiteSpace = doc.createTextNode(' ');
        composer.selection.insertNode(whiteSpace);
      },
    };
  },
};
